import { defineMessages, type MessageDescriptor } from 'react-intl';

export const messages: Record<
	'deepResearchTagLabel' | 'deepResearchTagDismissLabel' | 'agentDisabledTooltip',
	MessageDescriptor
> = defineMessages({
	deepResearchTagLabel: {
		id: 'conversation-assistant-chat-prompt-input.chat-prompt-input.deep-research-tag.deepResearchTagLabel',
		defaultMessage: 'Deep research',
		description:
			'Label for the deep research tag shown in the chat input when deep research is active',
	},
	deepResearchTagDismissLabel: {
		id: 'conversation-assistant-chat-prompt-input.chat-prompt-input.deep-research-tag.deepResearchTagDismissLabel',
		defaultMessage: 'Remove deep research',
		description:
			'Accessible label for the button that dismisses the deep research tag in the chat input',
	},
	agentDisabledTooltip: {
		id: 'conversation-assistant-chat-prompt-input.chat-prompt-input.deep-research-tag.agentDisabledTooltip',
		defaultMessage: 'Deep Research is only available when chatting with Rovo.',
		description:
			'Tooltip shown on the deep research tag when it is disabled because the user is chatting with an agent. It explains that Deep Research is available in regular Rovo Chat.',
	},
});
